const MODULE = document.querySelectorAll('[data-module="mapa_unidades"]');

const helpers = window.BASE_HELPERS || {};
const { Copy } = helpers;

class MapaUnidades {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        if (typeof google === 'undefined' || !google.maps) {
            return;
        }

        if (!window.unidadesLocations || !window.unidadesLocations.length) {
            return;
        }

        this.components.forEach(component => {
            this.initComponent(component);
        });
    }

    initComponent(component) {
        const mapContainer = component.querySelector('[data-map]');
        const cityFilter = component.querySelector('[data-city-filter]');
        const infoContainer = component.querySelector('.info-unidade');

        if (!mapContainer || !cityFilter) {
            return;
        }

        const locations = window.unidadesLocations;

        const defaultCenter = locations.length
            ? { lat: locations[0].latitude, lng: locations[0].longitude }
            : { lat: -14.235, lng: -51.9253 };

        const initialZoom = parseInt(mapContainer.dataset.zoom || '4', 10);

        const map = new google.maps.Map(mapContainer, {
            center: defaultCenter,
            zoom: initialZoom,
            mapTypeId: 'roadmap',
            disableDefaultUI: true,
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            mapId: AppSettings.googleMapId
        });

        const markers = [];

        const clearMarkers = () => {
            markers.forEach(m => {
                m.marker.setMap(null);
            });
            markers.length = 0;
        };

        const updateInfo = (locs) => {
            if (!infoContainer) return;

            const items = Array.isArray(locs) ? locs : (locs ? [locs] : []);

            if (!items.length) {
                infoContainer.innerHTML = '';
                return;
            }

            const getMapsLink = (lat, lng) => {
                if (!lat || !lng) return '#';
                return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
            };

            const copyIcon = `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.332 1.33325H6.66536C5.93003 1.33325 5.33203 1.93125 5.33203 2.66659V5.33325H2.66536C1.93003 5.33325 1.33203 5.93125 1.33203 6.66659V13.3333 C1.33203 14.0686 1.93003 14.6666 2.66536 14.6666H9.33203 C10.0674 14.6666 10.6654 14.0686 10.6654 13.3333V10.6666H13.332 C14.0674 10.6666 14.6654 10.0686 14.6654 9.33325V2.66659 C14.6654 1.93125 14.0674 1.33325 13.332 1.33325ZM2.66536 13.3333V6.66659H9.33203 L9.33336 13.3333H2.66536ZM13.332 9.33325H10.6654V6.66659 C10.6654 5.93125 10.0674 5.33325 9.33203 5.33325H6.66536V2.66659 H13.332V9.33325Z" fill="black"/>
                </svg>
                `;

            const html = items.map(loc => {
                const unidadesHtml = (loc.unidades_negocio || [])
                    .map(item => `<span class="text-lg text-principal-vermelho-vivo">${item.name}</span>`)
                    .join('<span class="separator"></span>');


                return `
                    <div class="info-unidade-item">
                        ${loc.imagem_desktop ? `
                            <div class="info-unidade-imagem mb-3">
                                <img src="${loc.imagem_desktop}" alt="${loc.title}" class="w-[555px] h-[245px] object-cover rounded-28">
                            </div>
                        ` : ''}

                        <div class="info-unidade-content">
                            <div class="flex items-center mb-2">
                                ${unidadesHtml}
                            </div>

                            <div class="flex flex-col gap-2 text-sm">
                                ${loc.endereco_completo ? `<p>${loc.endereco_completo}</p>` : ''}
                                ${(loc.telefone1 || loc.telefone2) ? `
                                    <p>Telefones:
                                        ${loc.telefone1 ? `
                                            ${loc.telefone1}
                                            <button data-copy="${loc.telefone1}" data-tooltip-position="right"
                                                class="transition-all ease-in-out hover:opacity-50">
                                                ${copyIcon}
                                            </button>
                                        ` : ''}

                                        ${loc.telefone1 && loc.telefone2 ? '<br>/' : ''}

                                        ${loc.telefone2 ? `
                                            ${loc.telefone2}
                                            <button data-copy="${loc.telefone2}" data-tooltip-position="right"
                                                class="transition-all ease-in-out hover:opacity-50">
                                                ${copyIcon}
                                            </button>
                                        ` : ''}
                                    </p>
                                ` : ''}

                                ${loc.email ?
                        `<p>
                                                <a href="mailto:${loc.email}">${loc.email}</a>
                                                <button data-copy="${loc.email}" data-tooltip-position="right" class="transition-all ease-in-out hover:opacity-50">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.332 1.33325H6.66536C5.93003 1.33325 5.33203 1.93125 5.33203 2.66659V5.33325H2.66536C1.93003 5.33325 1.33203 5.93125 1.33203 6.66659V13.3333C1.33203 14.0686 1.93003 14.6666 2.66536 14.6666H9.33203C10.0674 14.6666 10.6654 14.0686 10.6654 13.3333V10.6666H13.332C14.0674 10.6666 14.6654 10.0686 14.6654 9.33325V2.66659C14.6654 1.93125 14.0674 1.33325 13.332 1.33325ZM2.66536 13.3333V6.66659H9.33203L9.33336 13.3333H2.66536ZM13.332 9.33325H10.6654V6.66659C10.6654 5.93125 10.0674 5.33325 9.33203 5.33325H6.66536V2.66659H13.332V9.33325Z" fill="black"></path>
                                                    </svg>
                                                </button>
                                                </p>`
                        :
                        ''
                    }
                                ${loc.como_chegar ? `<p><a href="${loc.como_chegar}" target="_blank" rel="noopener noreferrer" class="hover:opacity-50">Como chegar</a></p>` : ''}
                                <a href="${getMapsLink(loc.latitude, loc.longitude)}" target="_blank" rel="noopener noreferrer" class="text-principal-vermelho-vivo underline">Como chegar</a>
                            </div >
                        </div >
                    </div >
                    `;
            }).join('');

            infoContainer.innerHTML = `
                <div div class="info-unidade-inner flex flex-col gap-6 overflow-auto h-full scrollbar-inner pr-3" >
                    ${html}
                </div >
            `;

            Copy.initCopy();
        };

        const renderMarkers = (filterCidade = '') => {
            clearMarkers();

            const filtered = locations.filter(loc => {
                if (!filterCidade) return true;
                const cidadeLoc = (loc.cidade_estado || '').trim();
                return cidadeLoc === filterCidade;
            });

            const bounds = new google.maps.LatLngBounds();

            filtered.forEach((loc) => {
                const position = { lat: loc.latitude, lng: loc.longitude };

                const marker = new google.maps.marker.AdvancedMarkerElement({
                    position,
                    map,
                    title: loc.title,
                });

                marker.addListener('click', () => {
                    updateInfo(filtered);
                });

                markers.push({
                    id: loc.id,
                    marker,
                    data: loc,
                });

                bounds.extend(position);
            });

            if (filtered.length > 0) {
                map.fitBounds(bounds);

                google.maps.event.addListenerOnce(map, 'idle', () => {
                    map.setZoom(14);
                    const mapDiv = map.getDiv();
                    const offsetX = mapDiv.offsetWidth * 0.2;
                    const center = map.getCenter();
                    const projection = map.getProjection();

                    if (!projection) return;

                    const point = projection.fromLatLngToPoint(center);
                    point.x += offsetX / Math.pow(2, map.getZoom());
                    const newCenter = projection.fromPointToLatLng(point);

                    map.setCenter(newCenter);
                });

                updateInfo(filtered);
            } else {
                map.setCenter(defaultCenter);
                map.setZoom(initialZoom);
                if (infoContainer) {
                    infoContainer.innerHTML = '';
                }
            }
        };

        const uniqueCities = [...new Set(
            locations
                .map(loc => (loc.cidade_estado || '').trim())
                .filter(c => c !== '')
        )].sort();

        uniqueCities.forEach(cidade => {
            const option = document.createElement('option');
            option.value = cidade;
            option.textContent = cidade;
            cityFilter.appendChild(option);
        });

        cityFilter.addEventListener('change', () => {
            renderMarkers(cityFilter.value);
        });

        //renderMarkers();
    }
}

(() => {
    if (MODULE && MODULE.length) {
        new MapaUnidades();
    }
})();

export default MapaUnidades;
